class InspirationDetailController {
    constructor($scope, $element, $location, analytics) {
        this.$scope = $scope;
        this.$element = $element;
        this.$location = $location;
        this.analytics = analytics;
    }

    $onInit() {
        this.analytics.push({ data: { card: this.card, list: this.$location.path() }, type: this.analytics.mapperTypes.content.inspiration });

        this.scheduleKey = `${this.card.ID}-card-schedule`;
    }

    $postLink() {
        this.$element[0].addEventListener('load', () => {
            // Re-triggers load whenever new images finish downloading in order
            // to correctly resize.
            this.$scope.$apply(() => this.onload());
        }, true);
    }
}

InspirationDetailController.$inject = ['$scope', '$element', '$location', 'AnalyticsService'];

const inspirationDetailComponentDefinition = {
    bindings: {
        card: '<',
        onload: '&',
    },
    controller: InspirationDetailController,
    template: require('./inspiration-detail.component.html').trim(),
};

module.exports = {
    InspirationDetailController,
    inspirationDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/inspiration/detail/inspiration-detail.component.js